export function isQuotaExceededError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as {
    code?: unknown;
    message?: unknown;
    name?: unknown;
  };
  const name =
    typeof candidate.name === 'string' ? candidate.name.toLowerCase() : '';
  const message =
    typeof candidate.message === 'string'
      ? candidate.message.toLowerCase()
      : '';

  return (
    name === 'quotaexceedederror' ||
    name === 'ns_error_dom_quota_reached' ||
    candidate.code === 22 ||
    candidate.code === 1014 ||
    message.includes('quotaexceeded') ||
    (message.includes('quota') && message.includes('exceed'))
  );
}

export function isLocalIndexedDBUnavailableError(error: unknown): boolean {
  if (isQuotaExceededError(error)) {
    return true;
  }
  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as {
    message?: unknown;
    name?: unknown;
  };
  const name =
    typeof candidate.name === 'string' ? candidate.name.toLowerCase() : '';
  const message =
    typeof candidate.message === 'string'
      ? candidate.message.toLowerCase()
      : '';

  return name === 'unknownerror' && message.includes('internal error');
}
